/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};

window.PXUTheme.jsSlideshowClassic = {
  init: function ($section) {

    // Settings aus Schema ziehen (wie im Original)
    window.PXUTheme.jsSlideshowClassic = $.extend(this, window.PXUTheme.getSectionData($section));

    // Slider-Element finden und IMMER sichtbar machen
    const $slideshowClassicEl = $section.find('[data-slideshow-classic]');
    $slideshowClassicEl.removeClass('is-hidden').css('display', 'block');

    // ✅ Mobile: Flickity aus – wir nutzen CSS scroll-snap (native swipe)
// ✅ Mobile: Flickity aus – aber Tap soll navigieren
if (window.matchMedia('(max-width: 798px)').matches) {

  let startX = 0, startY = 0, moved = false;

  $section[0].addEventListener('touchstart', (e) => {
    const t = e.touches && e.touches[0];
    if (!t) return;
    startX = t.clientX;
    startY = t.clientY;
    moved = false;
  }, { passive: true });

  $section[0].addEventListener('touchmove', (e) => {
    const t = e.touches && e.touches[0];
    if (!t) return;
    if (Math.abs(t.clientX - startX) > 10 || Math.abs(t.clientY - startY) > 10) {
      moved = true;
    }
  }, { passive: true });

  $section[0].addEventListener('click', (e) => {
    if (moved) {
      e.preventDefault();
      return;
    }

    const slide = e.target.closest && e.target.closest('.image-slideshow__slide');
    if (!slide) return;

    const link = slide.querySelector('a.banner--full-link');
    if (link && link.href) window.location.href = link.href;
  }, true);

  return; // <-- wichtig: Desktop-Code nicht ausführen
}


    // arrowShape kann je nach Bundle/Scope fehlen -> safe fallback
    const arrowShapeSafe = (typeof arrowShape !== 'undefined') ? arrowShape : null;

    // Flickity init (safe)
    try {
      const options = {
        wrapAround: true,
        adaptiveHeight: true,
        prevNextButtons: this.number_of_slides > 1 ? this.show_arrows : false,
        pageDots: this.number_of_slides > 1 ? this.show_nav_buttons : false,
        draggable: true,

        // smoother on mobile
        dragThreshold: 10,
        selectedAttraction: 0.02,
        friction: 0.28,

        imagesLoaded: true,
        fade: this.image_transition == 'fade',
        autoPlay: this.image_slideshow_speed * 1000
      };

      // arrowShape nur setzen, wenn vorhanden
      if (arrowShapeSafe) options.arrowShape = arrowShapeSafe;

      $slideshowClassicEl.flickity(options);

      // Resize when settled
      $slideshowClassicEl.on('settle.flickity', function () {
        try { $slideshowClassicEl.flickity('resize'); } catch (e) {}
      });

      // Extra resize hooks (mobile height glitches)
      setTimeout(() => { try { $slideshowClassicEl.flickity('resize'); } catch (e) {} }, 250);
      window.addEventListener('load', () => { try { $slideshowClassicEl.flickity('resize'); } catch (e) {} });
      window.addEventListener('orientationchange', () => {
        setTimeout(() => { try { $slideshowClassicEl.flickity('resize'); } catch (e) {} }, 300);
      });

    } catch (err) {
      // Wenn Flickity crasht: Slider bleibt zumindest sichtbar
      console.error('[SlideshowClassic] Flickity init failed:', err);
      $slideshowClassicEl.removeClass('is-hidden').css('display', 'block');
      return;
    }


    

  },

  blockSelect: function ($section, blockId) {
    // ✅ richtiger Selector
    const $slider = $section.find('[data-slideshow-classic]');
    const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');
    try { $slider.flickity('select', $sliderIndex, true, true); } catch (e) {}
  },

  unload: function ($section) {}
};

/******/ })();
